import { render, staticRenderFns } from "./PackingList.vue?vue&type=template&id=f80a6722&"
import script from "./PackingList.vue?vue&type=script&lang=js&"
export * from "./PackingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports